// extracted by mini-css-extract-plugin
export default {"quizAnimationContainer":"QuizAnimation_quizAnimationContainer__JsRo6","quizAnimation":"QuizAnimation_quizAnimation__JN1Lw"};